'use strict'

module.exports = class HomeWidgetModel extends Backbone.Model
  url: '/partial/homepage/widget'